// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--VuNce","row":"row--o5RyM","chip":"chip--mzvJG","overflow":"overflow--GEP7p","tooltipColumn":"tooltipColumn--cg1Xr"};